/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from "react";
import { Badge, Spin, Tabs } from "antd";
import WorkOrders from "./WorkOrders";
import Coc from "./Coc";
import TestMetrics from "./TestMetrics";
import EsvRetestActions from "./EsvRetestActions";
import SpecManagerDashboardWrapper from "../SpecsManager/SpecManagerDashboardWrapper";
import { canViewSpecManager } from "../SpecsManager/utils/utils";
import { canViewEsvActions } from "./EsvDataOpsCell";
import "./CocWoTabs.css";

const unreadBadgeCount = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) return 0;
  return parsed;
};

export default function CocWoTabs({
  customerId,
  customerAccountId,
  customerName,
  dateRange,
  filterRetest,
  searchParams,
  isCustomerEsvOnboarded,
  unreadActionCount,
  onUnreadCountChange,
}) {
  const [activeTabKey, setActiveTabKey] = useState("coc");

  if (isCustomerEsvOnboarded === null) {
    return (
      <div className="CocWoTabs CocWoTabs--loading">
        <Spin size="large" />
      </div>
    );
  }

  const hasValidSpecManagerCustomer = Boolean(customerAccountId);
  const showEsvTab = canViewSpecManager()
    && isCustomerEsvOnboarded === true
    && hasValidSpecManagerCustomer;

  const tabs = [
    {
      key: "coc",
      label: "COC",
      children: <Coc customerId={customerId} dateRange={dateRange} filterRetest={filterRetest} searchParams={searchParams} />,
    },
    {
      key: "workorders",
      label: "Workorders",
      children: <WorkOrders customerId={customerId} dateRange={dateRange} filterRetest={filterRetest} searchParams={searchParams} />,
    },
    {
      key: "results",
      label: "Results",
      children: (
        <div className="CocWoTabs__scrollableTablePane">
          <TestMetrics
            customerId={customerId}
            customerName={customerName}
            dateRange={dateRange}
            filterRetest={filterRetest}
            searchParams={searchParams}
          />
        </div>
      ),
    },
  ];

  if (canViewEsvActions()) {
    tabs.push({
      key: "esv-retest-actions",
      label: (
        <span className="CocWoTabs__TabLabel">
          ESV Actions
          {unreadBadgeCount(unreadActionCount) > 0 && (
            <Badge count={unreadBadgeCount(unreadActionCount)} color="#494b83" />
          )}
        </span>
      ),
      children: (
        <div className="CocWoTabs__embeddedPanel">
          <EsvRetestActions
            key={customerId}
            customerId={customerId}
            customerAccountId={customerAccountId}
            dateRange={dateRange}
            onUnreadCountChange={onUnreadCountChange}
          />
        </div>
      ),
    });
  }

  if (showEsvTab) {
    tabs.push({
      key: "esv-specs",
      label: "ESV Specs",
      children: (
        <div className="CocWoTabs__embeddedPanel">
          <SpecManagerDashboardWrapper
            key={`${customerId}-${customerAccountId}`}
            customer={{
              customer_id: customerAccountId,
              company: customerName,
            }}
          />
        </div>
      ),
    });
  }

  const activeKey = tabs.some((tab) => tab.key === activeTabKey) ? activeTabKey : "coc";

  return (
    <Tabs
      activeKey={activeKey}
      onChange={setActiveTabKey}
      destroyInactiveTabPane
      items={tabs}
      className="CocWoTabs"
    />
  );
}
